import { render, staticRenderFns } from "./addLeave.vue?vue&type=template&id=35db01b9&scoped=true&"
import script from "./addLeave.vue?vue&type=script&lang=js&"
export * from "./addLeave.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35db01b9",
  null
  
)

export default component.exports